import { FC } from "react";
import classNames from "classnames";
import TextEllipsis from "react-texas";
import Dropdown from "rc-dropdown";
import AccountIcon from "./AccountIcon";
import SettingIcon from "./SettingIcon";
import OpenInNew from "../LaunchPortalButton/OpenInNew";
import Menu from "../Menu";
import { gotoOAuthPortal } from "../../services/auth";
import { LS_KEY } from "../../constants";
import SignoutIcon from "./SignoutIcon";
import styles from "./index.module.css";
import { getLoginServerFromLocalStorage, clearSession } from "../../context/AuthContext";

interface IProps {
  theme: "light" | "dark";
  email: string;
  onlyShowIcon?: boolean;
}

const AccountDropdown: FC<IProps> = ({ theme, email, onlyShowIcon }) => {
  const iconColor = theme === "light" ? "#555" : "#dfdfdf";
  return (
    <Dropdown
      overlay={
        <Menu
          theme={theme}
          items={[
            {
              text: <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                Account Settings
                <OpenInNew color={iconColor} size={16} />
              </div>,
              icon: <SettingIcon color={iconColor} />,
              onClick: () => {
                const loginServer = getLoginServerFromLocalStorage();
                if (!loginServer) return;
                const url = new URL('/settings', loginServer);
                url.searchParams.set("email", email);
                window.open(url, "_blank", "noopener,noreferrer")
              },
            },
            {
              text: "Sign Out",
              icon: <SignoutIcon color={iconColor} />,
              onClick: () => {
                clearSession();
                gotoOAuthPortal("logout");
              },
            },
          ]}
        />
      }
      trigger={["hover"]}
    >
      <div
        className={classNames(styles["account"], {
          [styles["account-light"]]: theme === "light",
          [styles["account-dark"]]: theme === "dark",
        })}
      >
        <AccountIcon color={iconColor} />
        {!onlyShowIcon && <TextEllipsis>{email}</TextEllipsis>}
      </div>
    </Dropdown>
  );
};

export default AccountDropdown;
